(() => {
  if (window.noneunitSizeFitInitialized) return;
  window.noneunitSizeFitInitialized = true;

  const stripCentimeters = (rawValue) => rawValue.trim().replace(/\s*cm\b/gi, '').trim();

  const convertToInches = (rawValue) => {
    const source = stripCentimeters(rawValue);
    let convertedAny = false;
    const converted = source
      .replace(/\d+(?:\.\d+)?/g, (match) => {
        convertedAny = true;
        return (Number(match) * 0.3937007874).toFixed(1).replace(/\.0$/, '');
      });

    return convertedAny ? converted : source;
  };

  const animateUnitChange = (sizeFit) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    sizeFit.querySelectorAll('[data-size-fit-cm], [data-size-fit-unit-label]').forEach((item) => {
      item.getAnimations().forEach((animation) => animation.cancel());
      item.animate(
        [
          { opacity: 0.35, transform: 'translateY(2px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 180, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
    });
  };

  const animateSelectionChange = (element) => {
    if (!element || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    element.getAnimations().forEach((animation) => animation.cancel());
    element.animate(
      [
        { opacity: 0.45, transform: 'translateY(3px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ],
      { duration: 180, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    );
  };

  const mobileViewport = window.matchMedia('(max-width: 768px)');

  const syncNotesForViewport = () => {
    const isMobile = mobileViewport.matches;
    document.querySelectorAll('[data-size-fit-notes]').forEach((notes) => {
      const open = !isMobile;
      const summary = notes.querySelector('.noneunit-size-fit__notes-summary');
      const content = notes.querySelector('.noneunit-size-fit__notes-grid');
      notes.classList.toggle('is-open', open);
      if (summary) summary.setAttribute('aria-expanded', String(open));
      if (content) content.hidden = !open;
    });
  };

  document.addEventListener('click', (event) => {
    const notesSummary = event.target.closest('.noneunit-size-fit__notes-summary');
    if (!notesSummary) return;
    const notes = notesSummary.closest('[data-size-fit-notes]');
    if (!notes) return;
    event.preventDefault();
    const content = notes.querySelector('.noneunit-size-fit__notes-grid');
    const open = content ? content.hidden : !notes.classList.contains('is-open');
    notes.classList.toggle('is-open', open);
    notesSummary.setAttribute('aria-expanded', String(open));
    if (content) content.hidden = !open;
    if (open) animateSelectionChange(content);
  });

  document.addEventListener('click', (event) => {
    const styleButton = event.target.closest('[data-size-fit-style-trigger]');
    if (styleButton) {
      const sizeFit = styleButton.closest('.noneunit-size-fit');
      const selectedStyle = styleButton.dataset.sizeFitStyleTrigger;
      if (!sizeFit || styleButton.classList.contains('is-active')) return;

      sizeFit.querySelectorAll('[data-size-fit-style-trigger]').forEach((item) => {
        const active = item === styleButton;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });

      sizeFit.querySelectorAll('[data-size-fit-table-panel]').forEach((panel) => {
        const active = panel.dataset.sizeFitTablePanel === selectedStyle;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) animateSelectionChange(panel);
      });
      return;
    }

    const button = event.target.closest('[data-size-fit-unit]');
    if (!button) return;

    const sizeFit = button.closest('.noneunit-size-fit');
    if (!sizeFit) return;

    const unit = button.dataset.sizeFitUnit;
    if (unit !== 'cm' && unit !== 'in') return;
    if (button.classList.contains('is-active')) return;

    sizeFit.dataset.sizeFitCurrentUnit = unit;
    sizeFit.querySelectorAll('[data-size-fit-unit]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });

    sizeFit.querySelectorAll('[data-size-fit-unit-label]').forEach((label) => {
      label.textContent = unit.toUpperCase();
    });

    sizeFit.querySelectorAll('[data-size-fit-cm]').forEach((cell) => {
      const rawValue = cell.dataset.sizeFitCm;
      cell.textContent = unit === 'in' ? convertToInches(rawValue) : stripCentimeters(rawValue);
    });

    const status = sizeFit.querySelector('[data-size-fit-unit-status]');
    if (status) {
      status.textContent = unit === 'in' ? 'Measurements shown in inches' : 'Measurements shown in centimeters';
    }

    animateUnitChange(sizeFit);
  });

  syncNotesForViewport();
  if (mobileViewport.addEventListener) {
    mobileViewport.addEventListener('change', syncNotesForViewport);
  } else {
    mobileViewport.addListener(syncNotesForViewport);
  }
  document.addEventListener('shopify:section:load', syncNotesForViewport);
  document.addEventListener('on:variant:change', syncNotesForViewport);
})();
